<template>
  <div class="print-owe-fee-container">
    <el-card>
      <div class="text-center">
        <h1>{{ printPayFeeInfo.printName }}{{ $t('printOweFee.paymentNotice') }}</h1>
      </div>
      <div class="margin-top flex justify-between" style="color:#000;font-size:14px">
        <div >
          {{ $t('printOweFee.owner') }}：{{ printPayFeeInfo.ownerName }}
        </div>
        <div>
          {{ $t('printOweFee.printTime') }}：{{ printPayFeeInfo.feeTime }}
        </div>
      </div>
      <!-- 费用明细表格（原el-table） -->
      <table style="width: 100%; border-collapse: collapse; color: #000; font-size: 14px; margin-top: 10px;">
        <thead>
          <tr>
            <th style="border: 1px solid #dcdfe6; text-align: center;">{{$t('printOweFee.chargeObject')}}</th>
            <th style="border: 1px solid #dcdfe6; text-align: center;">{{$t('printOweFee.itemName')}}</th>
            <th style="border: 1px solid #dcdfe6; text-align: center;">{{$t('printOweFee.feePeriod')}}</th>
            <th style="border: 1px solid #dcdfe6; text-align: center;">{{$t('printOweFee.unit')}}</th>
            <th style="border: 1px solid #dcdfe6; text-align: center;">{{$t('printOweFee.areaUsage')}}</th>
            <th style="border: 1px solid #dcdfe6; text-align: center;">{{$t('printOweFee.unitPrice')}}</th>
            <th style="border: 1px solid #dcdfe6; text-align: center;">{{$t('printOweFee.amount')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, idx) in printPayFeeInfo.fees" :key="idx">
            <td style="border: 1px solid #dcdfe6; text-align: center;">{{ row.payerObjName }}</td>
            <td style="border: 1px solid #dcdfe6; text-align: center;">{{ row.feeName }}</td>
            <td style="border: 1px solid #dcdfe6; text-align: center;">
              <div v-if="row.preDegrees">
                {{ dateFormat(row.endTime) }}至{{ _getDeadlineTime(row) }}<br>
                {{ row.preDegrees }} 至 {{ row.curDegrees }}
              </div>
              <div v-else>
                {{ dateFormat(row.endTime) }}至{{ _getDeadlineTime(row) }}
              </div>
            </td>
            <td style="border: 1px solid #dcdfe6; text-align: center;">元</td>
            <td style="border: 1px solid #dcdfe6; text-align: center;">
              {{ row.preDegrees ? (row.curDegrees - row.preDegrees).toFixed(2) : printPayFeeInfo.builtUpArea }}
            </td>
            <td style="border: 1px solid #dcdfe6; text-align: center;">
              {{ row.preDegrees && row.mwPrice > 0 ? row.mwPrice : `${row.squarePrice}/${row.additionalAmount}` }}
            </td>
            <td style="border: 1px solid #dcdfe6; text-align: center;">{{ row.feeTotalPrice }}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #dcdfe6; text-align: center;" >
              {{$t('printOweFee.amountInWords')}}
            </td>
            <td style="border: 1px solid #dcdfe6; text-align: center;" colspan="4">
              {{ changeNumMoneyToChinese(printPayFeeInfo.feePrices) }}
            </td>
            <td style="border: 1px solid #dcdfe6; text-align: center;" colspan="2">
              {{ printPayFeeInfo.feePrices }}
            </td>
          </tr>
          <tr v-if="printPayFeeInfo.content">
          <td style="border: 1px solid #dcdfe6; width: 300px;">
            <div style="max-width: 600px;" v-html="printPayFeeInfo.content"></div>
          </td>
          <td style="border: 1px solid #dcdfe6; text-align: center;">
            <img :src="printPayFeeInfo.qrImg" width="150px" height="150px">
          </td>
        </tr>
        </tbody>
      </table>

      <!-- 扫码支付区（催缴单专属，业主扫此码直接支付，可长期有效） -->
      <div class="owe-fee-pay-block" v-if="printPayFeeInfo.feePrices > 0 && printPayFeeInfo.payObjId">
        <div class="owe-fee-pay-left">
          <div class="owe-fee-pay-title">{{ $t('printOweFee.scanToPay') || '微信扫码支付' }}</div>
          <div class="owe-fee-pay-amount">¥ {{ printPayFeeInfo.feePrices }}</div>
          <div class="owe-fee-pay-amount-zh">{{ changeNumMoneyToChinese(printPayFeeInfo.feePrices) }}</div>
          <div class="owe-fee-pay-tip">{{ $t('printOweFee.scanTip') || '业主使用微信扫描下方二维码，无需登录即可直接支付' }}</div>
          <div class="owe-fee-pay-expire">{{ $t('printOweFee.scanExpire') || '本二维码长期有效' }}</div>
        </div>
        <div class="owe-fee-pay-right">
          <div v-if="printPayFeeInfo.payCodeUrl" :id="oweFeeQrcodeBoxId" class="owe-fee-qrcode-box"></div>
          <div v-else class="owe-fee-qrcode-loading">{{ $t('printOweFee.qrcodeGenerating') || '二维码生成中...' }}</div>
        </div>
      </div>

      <div id="print-btn" class="margin-top ">
        <el-button type="primary" class="float-right" @click="_printPurchaseApplyDiv">
          <i class="el-icon-printer"></i>&nbsp;{{ $t('common.print') }}
        </el-button>
        <el-button type="warning" class="float-right" style="margin-right:20px;" @click="_closePage">
          {{ $t('common.cancel') }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { listOweFees, listRoomsWhereFeeSet, queryFeePrintSpec, genPrintOweFeeQrcode } from '@/api/fee/printOweFeeApi'
import { getCommunityId } from '@/api/community/communityApi'
import { dateFormat } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'
import QRCode from 'qrcodejs2'

export default {
  name: 'PrintOweFeeList',
  data() {
    return {
      printPayFeeInfo: {
        communityName: '',
        roomName: '',
        feePrices: 0.00,
        fees: [],
        feeTime: '',
        wechatName: '',
        content: '',
        qrImg: '',
        payObjId: '',
        builtUpArea: '',
        payObjType: '',
        payObjName: '',
        ownerName: '',
        printName: '',
        targetEndTime: '',
        payCodeUrl: '',
        payQrToken: ''
      },
      printFlag: '0',
      communityId: '',
      oweFeeQrcodeBoxId: 'owe-fee-qrcode-' + new Date().getTime() + '-' + Math.floor(Math.random() * 10000)
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._initData()
  },
  watch: {
    'printPayFeeInfo.payCodeUrl': function () {
      this._renderQrcode();
    }
  },
  methods: {
    _initData() {
      this.printPayFeeInfo.payObjId = this.$route.query.payObjId
      this.printPayFeeInfo.payObjType = this.$route.query.payObjType
      this.printPayFeeInfo.payObjName = this.$route.query.payObjName
      this.printPayFeeInfo.targetEndTime = this.$route.query.targetEndTime

      this._loadOweFees()
      this._printOweRoom()

      this.printPayFeeInfo.feeTime = dateFormat(new Date().getTime())
      this.printPayFeeInfo.communityName = this.communityId

      this._loadPrintSpec()
      this._genPayQrcode()
    },
    _genPayQrcode() {
      if (!this.printPayFeeInfo.payObjId || !this.printPayFeeInfo.payObjType || !this.communityId) {
        return;
      }
      genPrintOweFeeQrcode({
        communityId: this.communityId,
        payObjId: this.printPayFeeInfo.payObjId,
        payObjType: this.printPayFeeInfo.payObjType,
        payObjName: this.printPayFeeInfo.payObjName || '',
        ownerName: this.printPayFeeInfo.ownerName || ''
      }).then(res => {
        if (res && res.code === 0 && res.data) {
          this.printPayFeeInfo.payCodeUrl = res.data.codeUrl
          this.printPayFeeInfo.payQrToken = res.data.qrToken
        } else {
          console.log('催缴单二维码生成失败:', res)
        }
      }).catch(err => {
        console.log('生成催缴单二维码失败:', err)
      })
    },
    _renderQrcode() {
      if (!this.printPayFeeInfo.payCodeUrl) {
        return;
      }
      this.$nextTick(() => {
        let _box = document.getElementById(this.oweFeeQrcodeBoxId);
        if (!_box) {
          // 节点还不存在：通常是 _genPayQrcode 比 _loadOweFees 先回来，
          // 整块 v-if="feePrices>0" 容器还没渲染，DOM 不存在。
          // _loadOweFees 完成后会再次触发本方法，无需处理。
          console.log('qrcodejs2 容器节点尚未渲染，等 v-if 条件满足后自动重试');
          return;
        }
        _box.innerHTML = '';
        try {
          new QRCode(_box, {
            text: this.printPayFeeInfo.payCodeUrl,
            width: 180,
            height: 180,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        } catch (e) {
          console.log('qrcodejs2 渲染失败:', e)
        }
      })
    },
    _loadPrintSpec() {
      const param = {
        page: 1,
        row: 1,
        specCd: 1010,
        communityId: this.communityId
      }

      queryFeePrintSpec(param).then(res => {
        if (res.data.length > 0) {
          this.printPayFeeInfo.content = res.data[0].content
          this.printPayFeeInfo.qrImg = res.data[0].qrImg
          this.printPayFeeInfo.printName = res.data[0].printName
        }
      }).catch(err => {
        console.log('请求失败:', err)
      })
    },
    _printPurchaseApplyDiv() {
      this.printFlag = '1'
      document.getElementById("print-btn").style.display = "none"
      window.print()
      window.opener = null
      window.close()
    },
    _closePage() {
      window.opener = null
      window.close()
    },
    _printOweRoom() {
      if (this.printPayFeeInfo.payObjType !== '3333') {
        return
      }
      const param = {
        page: 1,
        row: 1,
        roomId: this.printPayFeeInfo.payObjId,
        communityId: this.communityId
      }

      listRoomsWhereFeeSet(param).then(res => {
        const listRoomData = res
        Object.assign(this.printPayFeeInfo, listRoomData.rooms[0])
        if (listRoomData.rooms[0].roomType === '2020602') {
          this.printPayFeeInfo.roomName = `${listRoomData.rooms[0].floorNum}-${listRoomData.rooms[0].roomNum}`
        } else {
          this.printPayFeeInfo.roomName = `${listRoomData.rooms[0].floorNum}-${listRoomData.rooms[0].unitNum}-${listRoomData.rooms[0].roomNum}`
        }
      }).catch(err => {
        console.log('请求失败:', err)
      })
    },
    _loadOweFees() {
      const param = {
        page: 1,
        row: 50,
        communityId: this.communityId,
        payObjId: this.printPayFeeInfo.payObjId,
        payObjType: this.printPayFeeInfo.payObjType,
        targetEndTime: this.printPayFeeInfo.targetEndTime,
      }

      listOweFees(param).then(res => {
        const _fees = res.data
        if (_fees.length < 1) {
          this.printPayFeeInfo.oweFees = []
          this.$message.warning(this.$t('printOweFee.noData'))
          return
        }
        this.printPayFeeInfo.fees = _fees
        let _totalAmount = 0.0
        this.printPayFeeInfo.fees.forEach(item => {
          _totalAmount += item.feeTotalPrice
        })
        _totalAmount = Math.round(_totalAmount * 100) / 100
        this.printPayFeeInfo.feePrices = _totalAmount
        // 异步竞态修复：如果 payCodeUrl 已经在 _genPayQrcode 早于 _loadOweFees 回来时赋值了，
        // 那时整块容器（v-if="feePrices>0"）还没渲染，watch 触发的 _renderQrcode 找不到 DOM 节点。
        // 现在 feePrices 赋值后容器已显示，主动再渲染一次。
        if (this.printPayFeeInfo.payCodeUrl) {
          this.$nextTick(() => {
            this._renderQrcode()
          })
        }
      }).catch(err => {
        console.log('请求失败:', err)
      })
    },
    _getDeadlineTime(_fee) {
      if (_fee.amountOwed === 0 && _fee.endTime === _fee.deadlineTime) {
        return "-"
      }
      if (_fee.state === '2009001') {
        return "-"
      }
      // 2026-07-26 兜底: 部分 fee（computingFormula=4004 动态费用）后端 deadlineTime 字段缺失
      // dateFormat('null') / dateFormat('') 会产生 "NaN-NaN-NaN"
      // 此时降级用 endTime 显示，避免 NaN
      const _dl = dateFormat(_fee.deadlineTime)
      if (_dl.indexOf('NaN') !== -1) {
        return dateFormat(_fee.endTime)
      }
      return _dl
    },
    dateFormat,
    changeNumMoneyToChinese
  }
}
</script>

<style scoped>
.print-owe-fee-container {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.float-right {
  float: right;
}

.text-center {
  text-align: center;
}
th{
  height: 40px;
}
td{
  height: 40px;
}
.owe-fee-pay-block {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  padding: 24px;
  border: 2px dashed #409eff;
  border-radius: 12px;
  background: linear-gradient(135deg, #f5f9ff 0%, #ecf5ff 100%);
  color: #000;
}
.owe-fee-pay-left {
  flex: 1;
  text-align: left;
  padding-right: 32px;
}
.owe-fee-pay-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}
.owe-fee-pay-amount {
  font-size: 36px;
  font-weight: 700;
  color: #f56c6c;
  margin-bottom: 6px;
}
.owe-fee-pay-amount-zh {
  font-size: 14px;
  color: #606266;
  margin-bottom: 12px;
}
.owe-fee-pay-tip {
  font-size: 13px;
  color: #606266;
  margin-bottom: 4px;
}
.owe-fee-pay-expire {
  font-size: 12px;
  color: #909399;
}
.owe-fee-pay-right {
  flex-shrink: 0;
}
.owe-fee-qrcode-box {
  width: 200px;
  height: 200px;
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.owe-fee-qrcode-loading {
  width: 200px;
  height: 200px;
  line-height: 200px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  text-align: center;
  color: #909399;
}
@media print {
  .owe-fee-pay-block {
    page-break-inside: avoid;
  }
  #print-btn {
    display: none !important;
  }
}
</style>